import { PropsWithChildren } from 'react';
import { Box, FelaCSS } from '@bridebook/ui';
import mergeStyles from '@bridebook/ui/src/fela-utils/merge-styles';
import { animationBlock, animationWrap, wrapStyle } from './skeleton-wrap.style';

interface IProps extends PropsWithChildren {
  style?: FelaCSS;
}

const SkeletonWrap = ({ children, style }: IProps) => (
  <Box style={mergeStyles([wrapStyle, { ...style }])}>
    <Box style={animationWrap}>
      <Box style={animationBlock} />
    </Box>
    <Box>{children}</Box>
  </Box>
);

export default SkeletonWrap;
